import { LESSONS, GET_LESSONS, setLessons } from "../actions/lessonsActions";
import { setLoader } from "../actions/uiActions";
import { setNotification } from "../actions/notificationActions";
import { takeLatest, put, call } from "redux-saga/effects";
import { db } from "../../firebase";

function* getLessons(action) {
  try {
    yield put(setLoader({ state: true, resource: LESSONS }));
    const ref = db.ref();
    const snap = yield call([ref, ref.once], "value");
    const val = snap.val();
    const value = val ? val["lessons"] : [];
    yield put(setLessons(value));
    yield put(setLoader({ state: false, resource: LESSONS }));
  } catch (error) {
    yield put(setLoader({ state: false, resource: LESSONS }));
    yield put(setNotification({ message: error.message, resource: LESSONS }));
  }
}

export default function* videoWatcher() {
  yield takeLatest(GET_LESSONS, getLessons);
}



// WEBPACK FOOTER //
// ./src/redux/middleware/lessonsMiddlerware.js